import { Fragment, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Alert, Button, Card, Col, Form, Image, Row } from 'react-bootstrap';
import Logo from 'assets/images/brand/logo/logo-icon.svg';
import UtilisateurService from '../services/UtilisateurService';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

const SignIn = () => {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const navigate = useNavigate();
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				await UtilisateurService.loginUser(username, password);

				// Reset the form and state variables after successful creation
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				navigate('/'); // Redirige vers la page d'accueil après une connexion réussie
			} catch (error) {
				console.error('Erreur lors de la tentative de connexion', error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}
	};

	return (
		<Fragment>
			<Form
				className="mb-2"
				noValidate
				validated={validated}
				onSubmit={handleSubmit}
			>
				<Row className="align-items-center justify-content-center g-0 min-vh-100">
					<Col lg={6} md={6} className="py-8 py-xl-0">
						<Card>
							<Card.Body className="p-6">
								<div className="mb-4">
									<Link to="/">
										<Image src={Logo} className="mb-4" alt="" />
									</Link>
									<h1 className="mb-1 fw-bold">Se connecter</h1>
								</div>
								{showAlert && (
									<Alert variant="danger">
										<ExclamationTriangleFill size={25} className="me-1" />
										{alertMessage}
									</Alert>
								)}
								<Row>
									<Col lg={12} md={12} className="mb-3">
										<Form.Label htmlFor="username">
											Nom d'utilisateur
										</Form.Label>
										<Form.Control
											name="username"
											type="username"
											placeholder="nom@example.com"
											id="username"
											required
											value={username}
											isInvalid={!!feedbackMessages['username']}
											onChange={(e) => {
												setUsername(e.target.value);
												const emailRegex =
													/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
												let errorMessage = '';
												if (!e.target.value) {
													errorMessage = "L'adresse saisie n'est pas valide.";
												} else if (!emailRegex.test(e.target.value)) {
													errorMessage =
														"L'adresse e-mail n'est pas dans un format valide.";
												}
												setFeedbackMessages((prevMessages) => ({
													...prevMessages,
													username: errorMessage
												}));
											}}
										/>
										<Form.Control.Feedback type="invalid">
											{feedbackMessages['username']}
										</Form.Control.Feedback>
									</Col>
									<Col lg={12} md={12} className="mb-3">
										<Form.Label htmlFor="password">
											Mot de passe <span className="text-danger">*</span>
										</Form.Label>
										<Form.Control
											name="password"
											type="password"
											placeholder="********"
											id="password"
											value={password}
											required
											isInvalid={!!feedbackMessages['password']}
											onChange={(e) => {
												setPassword(e.target.value);
												setFeedbackMessages((prevMessages) => ({
													...prevMessages,
													password: e.target.value
														? ''
														: 'Le password est requis.'
												}));
											}}
										/>
										<Form.Control.Feedback type="invalid">
											{feedbackMessages['password']}
										</Form.Control.Feedback>
									</Col>
									<Col lg={12} md={12} className="mb-3">
										{/* Checkbox */}
										<div className="d-md-flex justify-content-between align-items-center">
											<Form.Group
												className="mb-3 mb-md-0"
												controlId="formBasicCheckbox"
											>
												<Form.Check type="checkbox" label="Remember me" />
											</Form.Group>
											{/*<Link to="/authentication/forget-password">*/}
											{/*    Mot de passe oublié?*/}
											{/*</Link>*/}
										</div>
									</Col>
									<Col lg={12} md={12} className="mb-0 d-grid gap-2">
										{/* Button */}
										<Button variant="primary" type="submit">
											Se connecter
										</Button>
									</Col>
								</Row>
								<hr className="my-4" />
								<div className="mt-4 text-center">
									<span className="mb-1">
										Situe au lieudit *carrefour la vie continue* NGONA 200m de
										la route principale
									</span>
									<br></br>
									<span className="mb-1">
										Tel : 675 51 88 55 / 699 90 93 21 / 691 77 45 65
									</span>
									<br></br>
									<span className="mb-1">Email : FFEM@gmail.com</span>
								</div>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			</Form>
		</Fragment>
	);
};

export default SignIn;
